
export enum LatestUpdateType {
    CategoryDetailLatestUpdate,
    CountryDashboardDescriptionLatestUpdate,
    EventLatestUpdate,
    GenericLatestUpdate
}

export abstract class LatestUpdate {
    constructor(countryId: number, businessFunctionId: number, description: string, url: string, latestUpdateType: LatestUpdateType) {
        this.countryId = countryId;
        this.businessFunctionId = businessFunctionId;
        this.description = description;
        this.url = url;
    }
    countryId: number;
    countryName!: string;
    countryCode!: string;
    businessFunctionId: number;
    description: string;
    url: string;
    createdDate!: string;
    disabled!: boolean;
    latestUpdateType!: LatestUpdateType;
}

export class CategoryDetailLatestUpdate extends LatestUpdate {
    constructor(countryId: number, businessFunctionId: number, description: string, url: string) {
        super(countryId, businessFunctionId, description, url, LatestUpdateType.CategoryDetailLatestUpdate);
    }
}

export class CountryDashboardDescriptionLatestUpdate extends LatestUpdate {
    constructor(countryId: number, businessFunctionId: number, description: string, url: string) {
        super(countryId, businessFunctionId, description, url, LatestUpdateType.CountryDashboardDescriptionLatestUpdate);
    }
}

export class EventLatestUpdate extends LatestUpdate {
    constructor(countryId: number, businessFunctionId: number, description: string, url: string) {
        super(countryId, businessFunctionId, description, url, LatestUpdateType.EventLatestUpdate);
    }
}

export class GenericLatestUpdate extends LatestUpdate {
    constructor(countryId: number, businessFunctionId: number, description: string, url: string) {
        super(countryId, businessFunctionId, description, url, LatestUpdateType.GenericLatestUpdate);
    }
}